import React from "react";

export const ChevronDownSVG: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 6l3.5 3.5L11.5 6"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExcelIconSVG: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.2001 3.59998H12.6001V14.4H16.2001V3.59998Z" fill="#1E1E1E" />
    <path
      d="M1.79999 14.4L11.88 17.1V0.900024L1.79999 3.60002V14.4ZM4.31999 5.40002H5.92199L6.82199 7.39802L7.75799 5.40002H9.32399L7.68599 8.26202L9.48599 11.628H7.88399L6.82199 9.25202L5.77799 11.628H4.21199L5.95799 8.31602L4.31999 5.40002Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const PDFIconSVG: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.266 2.47634L14.4166 2.47889L12.7195 0.827148V1.9285C12.7195 2.23022 12.9649 2.4757 13.266 2.47634Z"
      fill="#1E1E1E"
    />
    <path
      d="M14.9523 3.21073L13.2648 3.20689C12.5617 3.20498 11.9896 2.63161 11.9896 1.92849L11.989 0.327271H3.50608C3.25358 0.327271 3.0484 0.532454 3.0484 0.784945V6.20802H14.9529L14.9523 3.21073Z"
      fill="#1E1E1E"
    />
    <path
      d="M3.04775 16.2333C3.04775 16.4858 3.25293 16.6909 3.50542 16.6909H14.4939C14.7464 16.6909 14.9516 16.4858 14.9516 16.2333L14.9522 12.0682H3.0477L3.04775 16.2333Z"
      fill="#1E1E1E"
    />
    <path
      d="M8.47263 8.31861V10.1608C8.96034 10.2784 9.72227 9.87638 9.66346 9.23973C9.56566 8.17482 8.47263 8.31861 8.47263 8.31861Z"
      fill="#1E1E1E"
    />
    <path
      d="M5.95865 8.3186H5.26001V9.08118H5.95865C6.16896 9.08118 6.33962 8.91051 6.33962 8.70022C6.33962 8.48928 6.16894 8.3186 5.95865 8.3186Z"
      fill="#1E1E1E"
    />
    <path
      d="M1.73993 6.93848V11.3375H16.26V6.93848H1.73993ZM5.95864 9.81111H5.25999V10.5257C5.25999 10.7277 5.09636 10.8907 4.895 10.8907C4.69301 10.8907 4.53001 10.7271 4.53001 10.5257V7.95289C4.53001 7.7509 4.69365 7.5879 4.895 7.5879H5.95928C6.57227 7.5879 7.07086 8.08648 7.07086 8.69948C7.07022 9.31248 6.57164 9.81111 5.95864 9.81111ZM8.74307 10.8914H8.10771C7.90571 10.8914 7.74272 10.7277 7.74272 10.5264V7.95353C7.74272 7.75154 7.90635 7.58854 8.10771 7.58854H8.74307C9.65394 7.58854 10.3948 8.32937 10.3948 9.24028C10.3942 10.1505 9.65335 10.8914 8.74307 10.8914ZM13.105 8.31852H11.8189V8.81071H12.9145C13.1165 8.81071 13.2795 8.97434 13.2795 9.1757C13.2795 9.37769 13.1158 9.54069 12.9145 9.54069H11.8189V10.5251C11.8189 10.7271 11.6552 10.89 11.4539 10.89C11.2519 10.89 11.0889 10.7264 11.0889 10.5251V7.9522C11.0889 7.75021 11.2525 7.58721 11.4539 7.58721H13.1056C13.3076 7.58721 13.4706 7.75085 13.4706 7.9522C13.4706 8.15483 13.307 8.31852 13.105 8.31852Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const ExportIconSVG: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z"
      fill="currentColor"
    />
  </svg>
);
